module.exports = __webpack_public_path__ + "img/icon_send_on.37e333bf.svg";